import { FileText } from 'lucide-react';
import { formatMoneyCOP } from '../../utils/formatMoney.js';
import { getTarifasForSedeId } from '../../constants/vacacionesTarifas.js';

function TarifaHabitacionSedeTable({ tarifa }) {
  return (
    <div className="overflow-x-auto rounded-xl ring-1 ring-slate-200">
      <table className="w-full min-w-[36rem] text-left text-sm">
        <thead>
          <tr className="bg-[#67b235] text-xs font-semibold uppercase tracking-wide text-white">
            {tarifa.columnas.map((col) => (
              <th key={col} className="px-3 py-3 first:min-w-[7rem]">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200 bg-white">
          {tarifa.filas.map((fila) => (
            <tr key={fila.tipo}>
              <td className="px-3 py-3 font-medium text-slate-800">{fila.tipo}</td>
              {fila.dias.map((valor, i) => (
                <td key={i} className="px-3 py-3 text-slate-700">
                  {formatMoneyCOP(valor)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function TarifaPortalesSedeTables({ tarifa }) {
  return (
    <div className="space-y-8">
      {tarifa.casas.map((casa) => (
        <div key={casa.nombre} className="space-y-3">
          <h4 className="font-display text-lg font-semibold text-accent-blue">{casa.nombre}</h4>
          <div className="overflow-x-auto rounded-xl ring-1 ring-slate-200">
            <table className="w-full min-w-[28rem] text-left text-sm">
              <thead>
                <tr className="bg-[#67b235] text-xs font-semibold uppercase tracking-wide text-white">
                  {tarifa.columnas.map((col) => (
                    <th key={col} className="px-4 py-3">
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200 bg-white">
                {casa.filas.map((fila) => (
                  <tr key={fila.tipo}>
                    <td className="px-4 py-3 font-medium text-slate-800">{fila.tipo}</td>
                    <td className="px-4 py-3 text-slate-700">{formatMoneyCOP(fila.valor)}</td>
                    <td className="px-4 py-3 text-slate-700">{formatMoneyCOP(fila.adicional)}</td>
                    <td className="px-4 py-3 font-semibold text-slate-800">{formatMoneyCOP(fila.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default function VacacionTarifasSede({ sedeId, className = '' }) {
  const tarifa = getTarifasForSedeId(sedeId);
  if (!tarifa) return null;

  const isHabitacion = 'filas' in tarifa && Array.isArray(tarifa.filas);

  return (
    <section className={className}>
      <h3 className="flex items-center gap-2 font-display text-xl font-semibold text-accent-blue">
        <FileText className="h-5 w-5 text-accent-lime" aria-hidden />
        {tarifa.titulo}
      </h3>
      <p className="mt-2 text-sm text-slate-600">{tarifa.nota}</p>
      <div className="mt-4">
        {isHabitacion ? <TarifaHabitacionSedeTable tarifa={tarifa} /> : <TarifaPortalesSedeTables tarifa={tarifa} />}
      </div>
      {isHabitacion && tarifa.pago?.length > 0 ? (
        <ul className="mt-4 list-inside list-disc space-y-1 text-sm text-slate-600">
          {tarifa.pago.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
